import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import Layout from '@components/common/Layout';
import SatDataGrid from '@components/common/satUI/SatDataGrid';
import SatDatePicker from '@components/common/satUI/SatDatePicker';
import SatPagination from '@components/common/satUI/SatPagination';

import { getDateByformat } from '@common/utils';

import {
  showModal,
  getHqListByChannel,
  getAgencyListByHq,
} from '@store/actions/commonAction';

import {
  getCommonCodeDtlList,
  getProdSaleQuitMethodCd,
  getProdSaleImpsAgncRegedList,
  getPrdtByChannel,
  getProdSaleImpsAgncRegedListClear,
} from '@store/actions/managementProductAction';

const columns = [
  { title: '상품군', width: '5%', key: 'prodGrpNm', dataIndex: 'prodGrpNm' },
  { title: '상품코드', width: '9%', key: 'prodCd', dataIndex: 'prodCd' },
  { title: '상품명', width: '35%', key: 'prodNm', dataIndex: 'prodNm' },
  { title: '채널', width: '7%', key: 'orgChnlNm', dataIndex: 'orgChnlNm' },
  { title: '본부', width: '7%', key: 'hqCdNm', dataIndex: 'hqCdNm' },
  { title: '지점', width: '7%', key: 'agncCdNm', dataIndex: 'agncCdNm' },
  {
    title: '상품판매불가처리방법',
    width: '',
    key: 'saleQuitProcMethdNm',
    dataIndex: 'saleQuitProcMethdNm',
  },
  {
    title: '시작일자',
    width: '10%',
    key: 'saleQuitStrtDd',
    dataIndex: 'saleQuitStrtDd',
  },
  {
    title: '종료일자',
    width: '10%',
    key: 'saleQuitEndDd',
    dataIndex: 'saleQuitEndDd',
  },
];

const ManagementSystemUnavailable = () => {
  const {
    commonCodeDtl,
    prodSaleQuitMethod,
    salempsAgncReged: { list, rows, targetRow, prdtList },
  } = useSelector(state => state.managementProductReducer);

  const { hqList, agencyList } = useSelector(state => state.commonReducer);

  const dispatch = useDispatch();
  const history = useHistory();

  const [searchVal, setSearchVal] = useState({
    orgChnlCd: '', //채널
    hqCd: '', //본부
    agncCd: '', //지점
    prodGrpCd: '', //상품군
    prodNm: '', //상품명
    saleQuitStrtDd: '', //기준일자
  });
  const [grid, setGrid] = useState([]);

  useEffect(() => {
    dispatch(
      getCommonCodeDtlList({
        cdTyId: 'ORG_CHNL_CD',
      }),
    );

    dispatch(
      getProdSaleQuitMethodCd({
        cdTyId: 'SALE_QUIT_PROC_METHD_CD',
      }),
    );
  }, []);

  useEffect(() => {
    return () => {
      dispatch(getProdSaleImpsAgncRegedListClear());
    };
  }, []);

  useEffect(() => {
    if (list.length === 0 && targetRow !== 0) {
      dispatch(
        showModal({
          visible: true,
          type: 'info',
          msg: '검색결과가 없습니다.',
        }),
      );
    }

    let tmp = [...list];

    tmp.forEach(item => {
      item.orgChnlNm = commonCodeDtl.filter(
        cd => cd.cdVal === item.orgChnlCd,
      )[0].cmnCdNm;
      item.saleQuitStrtDd = getDateByformat(item.saleQuitStrtDd, 'yyyy.MM.dd');
      item.saleQuitEndDd = getDateByformat(item.saleQuitEndDd, 'yyyy.MM.dd');
      item.saleQuitProcMethdNm = prodSaleQuitMethod.filter(
        cd => cd.cdVal === item.saleQuitProcMethdCd,
      )[0].cmnCdNm;
    });
    setGrid(tmp);
  }, [list]);

  useEffect(() => {
    if (prdtList.length === 0) {
      setSearchVal({
        ...searchVal,
        ['prodGrpCd']: '',
      });
    }
  }, [prdtList]);

  useEffect(() => {
    dispatch(
      getHqListByChannel({
        chnlCd: searchVal.orgChnlCd,
      }),
    );
  }, [searchVal.orgChnlCd]);

  useEffect(() => {
    dispatch(
      getAgencyListByHq({
        chnlCd: searchVal.orgChnlCd,
        hqCd: searchVal.hqCd,
      }),
    );
  }, [searchVal.hqCd]);

  const onOptionChange = e => {
    const { name, value } = e.target;

    if (name === 'orgChnlCd') {
      dispatch(
        getPrdtByChannel({
          orgChnlCd: value,
        }),
      );
      setSearchVal({
        ...searchVal,
        ['orgChnlCd']: value,
        ['hqCd']: '',
        ['agncCd']: '',
      });
    } else if (name === 'hqCd') {
      setSearchVal({
        ...searchVal,
        ['hqCd']: value,
        ['agncCd']: '',
      });
    } else if (name === 'agncCd') {
      setSearchVal({
        ...searchVal,
        ['agncCd']: value,
      });
    } else {
      setSearchVal({
        ...searchVal,
        [name]: value,
      });
    }
  };
  const onChange = e => {
    const { name, value } = e.target;

    setSearchVal({
      ...searchVal,
      [name]: value,
    });
  };
  const onKeyDown = e => {
    if (e.keyCode === 13) {
      e.preventDefault();
      onSearch();
    }
  };
  const onSearch = () => {
    if (searchVal.orgChnlCd.trim() === '') {
      dispatch(
        showModal({
          visible: true,
          type: 'info',
          msg: '채널을 선택해주세요.',
          moveFocus: true,
        }),
      );
      return;
    }

    dispatch(getProdSaleImpsAgncRegedList(searchVal));
  };

  return (
    <Layout>
      <div className="con-wrap">
        <div className="app-wrap">
          <div className="app-box">
            <div className="con-bottom">
              <div className="tit-area">
                <h2 className="tit-con">판매불가상품관리</h2>
              </div>
              <div className="text-info flex mgt-20 mgb-20">
                <span className="ico ico-info-yellow"></span>
                종료일자가 9999.12.31일 경우는 계속 판매 중지 상품
              </div>
              <div className="search-box">
                <div className="data-group-left">
                  <div className="data-area">
                    <span className="data-tit">채널</span>
                    <div className="sel-group">
                      <select
                        name="orgChnlCd"
                        value={searchVal.orgChnlCd}
                        onChange={onOptionChange}
                      >
                        <option value="">전체</option>
                        {commonCodeDtl.map((item, index) => (
                          <option key={`comCode_${index}`} value={item.cdVal}>
                            {item.cmnCdNm}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
                <div className="data-group-left">
                  <div className="data-area">
                    <span className="data-tit">본부</span>
                    <div className="sel-group">
                      <select
                        name="hqCd"
                        value={searchVal.hqCd}
                        onChange={onOptionChange}
                      >
                        <option value="">전체</option>
                        {hqList.map((item, index) => (
                          <option key={`hqCd_${index}`} value={item.hqCd}>
                            {item.hqNm}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
                <div className="data-group-left">
                  <div className="data-area">
                    <span className="data-tit">지점</span>
                    <div className="sel-group">
                      <select
                        name="agncCd"
                        value={searchVal.agncCd}
                        onChange={onOptionChange}
                      >
                        <option value="">전체</option>
                        {agencyList.map((item, index) => (
                          <option key={`agency_${index}`} value={item.agncCd}>
                            {item.agncNm}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
                <div className="data-group-left">
                  <div className="data-area">
                    <span className="data-tit">상품</span>
                    <div className="sel-group">
                      <select
                        name="prodGrpCd"
                        value={searchVal.prodGrpCd}
                        onChange={onOptionChange}
                      >
                        <option value="">전체</option>
                        {prdtList.map((item, index) => (
                          <option
                            key={`prdtList_${index}`}
                            value={item.saleProdGrpCd}
                          >
                            {item.saleProdGrpNm}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="input-wrap input-search">
                      <input
                        type={'text'}
                        id={'text1'}
                        name="prodNm"
                        className={'input'}
                        placeholder={'상품명을 입력하세요.'}
                        onChange={onChange}
                        onKeyDown={onKeyDown}
                      />
                    </div>
                  </div>
                </div>
                <div className="data-group-left">
                  <div className="data-area">
                    <span className="data-tit">판매중지 시작일</span>
                    <SatDatePicker
                      value={searchVal.saleQuitStrtDd}
                      onChange={value => {
                        setSearchVal({
                          ...searchVal,
                          saleQuitStrtDd: value,
                        });
                      }}
                      viewIcon={true}
                    />
                  </div>
                </div>
                <button className="btn-search" onClick={onSearch}>
                  검색
                </button>
              </div>
              <div className="table-wrap-reg">
                <div className="tit-mini mgt-20">전체 {rows}건</div>
                <div className="table-wrap table-wrap-scroll">
                  {/* 그리드 */}
                  <SatDataGrid
                    columns={columns}
                    dataSource={grid}
                    noDataRender={'검색결과가 없습니다.'}
                  />
                </div>
              </div>
              {/* 페이징 */}
              {rows > 10 && (
                <SatPagination
                  totalCount={rows}
                  onChange={index => {
                    dispatch(
                      getProdSaleImpsAgncRegedList({
                        ...searchVal,
                        targetRow: index * 10 + 1,
                      }),
                    );
                  }}
                />
              )}
            </div>

            <div className="btn-area-jb">
              <ul className="file-list">
                <li>
                  <button
                    className="btn-m add"
                    onClick={() =>
                      history.push('/management/system/unavailable-reg')
                    }
                  >
                    등록
                  </button>
                </li>
                <li>
                  <button
                    className="btn-m modify"
                    onClick={() =>
                      history.push('/management/system/unavailable-mod')
                    }
                  >
                    수정
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ManagementSystemUnavailable;
